import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "./header.css";
import { Link } from "react-router-dom";
import One from "../../asset/3.jpg";
import Two from "../../asset/2.jpg";
import Three from "../../asset/4.jpg";
import Prayer from "../page/prayerTimer";
import Navbar from "../navbar";
import Footer from "../Footer";

const Header = () => {
  return (
    <>
      <Navbar />
      <Grid
        container
        sx={{
          background: "#2F70FE",
          display: "flex",
          justifyContent: "space-around",
          padding: "50px 0",
        }}
      >
        <Grid item xs={10} md={5} sx={{ alignSelf: "center" }}>
          <Typography className="text">Islamic Center Of Cape Cod</Typography>
          <Typography className="text2">
            “Indeed, I am near.” [Quran 2:186]
          </Typography>
          <Link style={{ textDecoration: "none" }} to="/donate">
            <Button
              className="main-btn"
              sx={{
                fontWeight: "700",
                color: "white",
                border: "1px solid white",
                width: "40%",
                borderRadius: "20px",
                marginTop: "10px",
                textTransform: "capitalize",
              }}
            >
              Donate Us
            </Button>
          </Link>
        </Grid>
        <Grid item xs={10} md={5}>
          <Typography className="noticetxt" sx={{ color: "white" }}>
            Notice To The Local Muslim Comunity OF Cape Cod!
          </Typography>
          <Typography
            className="noticetext2"
            sx={{ padding: "50px 0", color: "white" }}
          >
            <b>1:</b> *Eid Announcement *
On behalf of Islamic Center of Cape Cod we would like to announce that Eid-ul-Azha will be InshaAllah on Sunday June 16, 2024.
          </Typography>
          <Typography
            className="noticetext2"
            sx={{ padding: "50px 0", color: "white" }}
          >
            <b>2:</b> *Venue*
            Eid Prayer will be at Resort & Conference Center Hyannis 
            (*Cape Cod Irish Village*) 
            35 Scudder Avenue Hyannis, MA. 02601. 
            Eid Prayer will be:
            -For Men : Ballroom 1
            -For Women : Ballroom 2
            Please Note these Hall are on Ground Floor.
            After the Eid Prayers *Breakfast* will be served as well.
            Prayer Timing will be at sharp *8:30 AM* in the morning.

          </Typography>
          <Typography className="noticetext2" sx={{ color: "white" }}>
            <b>3:</b>*Note*
            There will be only *ONE*Time Eid Prayer.

We invite you all to join us on Eid day along with your families and friends.
We wish you all a very Eid Mubarak. 
May Allah Almighty showers His countless blessings upon you and your family. Ameen

For more Information Please call
Muhammad Rafiq : 508/265/1898
Javid Zahid : 508/360/4450
Saeed Chaudhry : 508/274/6666
Muhammad Shakeel : 508/566/6338
          </Typography>
        </Grid>
      </Grid>
      <Prayer />
      <Grid
        container
        sx={{ margin: "40px 0", diplay: "flex", justifyContent: "center" }}
      >
        <Grid item xs={10} md={5} className="home-img">
          <img className="One" src={One} alt="nothing to show" />
        </Grid>
        <Grid item xs={10} md={5} sx={{ alignSelf: "center" }}>
          <Typography className="text5">
            “And Allah has sent down rain from the sky and given life thereby to
            the earth after its lifelessness. Indeed in that is a sign for a
            people who listen.”<b> Surah An-Nahl [16:65].</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ margin: "40px 0", diplay: "flex", justifyContent: "center" }}
      >
        <Grid className="org-txt" item md={5} sx={{ alignSelf: "center" }}>
          <Typography className="text5">
            “And Allah has sent down rain from the sky and given life thereby to
            the earth after its lifelessness. Indeed in that is a sign for a
            people who listen.” <b>Surah An-Nahl [16:65].</b>
          </Typography>
        </Grid>
        <Grid
          item
          className="home-img"
          xs={10}
          md={5}
          sx={{ display: "flex", justifyContent: "end" }}
        >
          <img className="One" src={Two} alt="nothing to show" />
        </Grid>
        <Grid
          className="copy-txt"
          item
          xs={10}
          md={5}
          sx={{ alignSelf: "center" }}
        >
          <Typography className="text5">
            “And Allah has sent down rain from the sky and given life thereby to
            the earth after its lifelessness. Indeed in that is a sign for a
            people who listen.” <b>Surah An-Nahl [16:65].</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ margin: "40px 0", diplay: "flex", justifyContent: "center" }}
      >
        <Grid item xs={10} md={5} className="home-img">
          <img className="One" src={Three} alt="nothing to show" />
        </Grid>
        <Grid item xs={10} md={5} sx={{ alignSelf: "center" }}>
          <Typography className="text5">
            “And Allah has sent down rain from the sky and given life thereby to
            the earth after its lifelessness. Indeed in that is a sign for a
            people who listen.” <b>Surah An-Nahl [16:65].</b>
          </Typography>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default Header;
